import {Action, Module, Mutation} from 'vuex-module-decorators'
import store from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import StudyShortDto = MdbsCore.StudyShortDto;

const studyClient = new MdbsCore.StudyClient();

@Module({namespaced: true, name: 'studies', store: store})
export default class StudiesModule extends BaseModule {
    studies = new Array<StudyShortDto>();

    @Mutation
    setStudies(studies: Array<StudyShortDto>) {
        this.studies.updateValues(studies);
    }

    @Mutation
    reset() {
        this.studies.clear();
    }

    @Action({rawError: true})
    async loadAll(includeDeleted?: boolean) {
        await this.execute(async () =>
            this.setStudies(await studyClient.getAllStudys(includeDeleted))
        ).catch(() => this.reset());
    }

    @Action({rawError: true})
    async loadMy(includeDeleted?: boolean) {
        await this.execute(async () =>
            this.setStudies(await studyClient.getMyStudys(includeDeleted))
        ).catch(() => this.reset());
    }
}
